module.exports = __webpack_public_path__ + "img/img_banner.01b1d7a2.png";